export default __webpack_public_path__ + "static/media/successDesktop_bg.2ee427c3.png";